import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import ErrorBoundary from '../../../../molecules/ErrorBoundary'
import AutoTable from './AutoTable'

const useStyles = makeStyles((theme) => ({
  resultPanel: {
    width: '100%',
    height: '100%',
    backgroundColor: 'var(--surface-bg-color-d4)',
    borderTop: 'var(--border-neutral-thin)',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '1fr',
    gap: '0px 0px',
    gridTemplateAreas: '"result-body"',
    '& .__result-header': {
      gridArea: 'result-header'
    },
    '& .__result-body': {
      gridArea: 'result-body',
      overflow: 'scroll',
      height: '100%',
      width: '100%'
    },
    '& .__field-info': {
      gridArea: 'field-info',
      overflow: 'scroll',
      height: '100%',
      width: '100%'
    }
  }
}))

function ResultPanel ({ currentResult }) {
  const classes = useStyles()

  return (
    <div className={classes.resultPanel}>
      <ErrorBoundary name='Results'>
        <div className='__result-body'>
          {(currentResult?.data || []).length ? (
            <AutoTable data={currentResult?.data} />
          ) : (
            <div>No Result</div>
          )}
        </div>
      </ErrorBoundary>
    </div>
  )
}

ResultPanel.propTypes = {
  currentResult: PropTypes.any
}

export default ResultPanel
